<template>
  <div id="page">
    <div class="container">
      <div class="row width_full mb_20">
        <div class="col_12">
          <div class="common_title">
            <h2>{{ user ? user.name : '' }}</h2>
          </div>
          <div class="row" v-if="user">
            <div class="col_12">
            <table>
              <tr>
                <th class="text_left">First Name:</th>
                <td>{{ user.name }}</td>
              </tr>
              <tr>
                <th class="text_left">Email:</th>
                <td>{{ user.email }}</td>
              </tr>
              <tr>
                <th class="text_left">Username:</th>
                <td>{{ user.user_name }}</td>
              </tr>
              <tr>
                <th class="text_left">User Type:</th>
                <td>{{ user.user_type }}</td>
              </tr>
              <tr>
                <th class="text_left">Address:</th>
                <td>{{ user.address }}</td>
              </tr>
              <tr>
                <th class="text_left">Cell Phone:</th>
                <td>{{ user.cell_phone }}</td>
              </tr>
              <tr>
                <th class="text_left">Contact:</th>
                <td>{{ user.contact }}</td>
              </tr>
              <tr>
                <th class="text_left">Join Date:</th>
                <td>{{ user.created_at }}</td>
              </tr>
              <tr>
                <th class="text_left">Date of Birth:</th>
                <td>{{ user.dob }}</td>
              </tr>
            </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Details",
  data(){
    return {
      user: null
    }
  },
  created() {
    this.axios.get('/customers/'+this.$route.params.id).then((response) => {
      this.user = response.data.data
    });
  }
}
</script>

<style scoped>

</style>